import * as App from "./app";
import * as Auth from "./auth";

// List modules for chunks "auth.html"
export default [App, Auth];
